import React, {Component} from "react";
 // import logo from './../../assets/images/logo_test.png';
// import logo from './../../assets/images/logo_mxl.png';
// import logo from './../../assets/images/logo_v2.png';
//import logo from './../../assets/images/logo/bg1.png';
// import logo from './../../assets/images/logo/bg2.png';
import logo from './../../assets/images/logo.png';
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {clearFilter} from "../redux/actions/event-filter";

class Logo extends Component {
	clearFilter() {
		this.props.onClearFilter();
	}

	render() {
		return (
			<div className="header__logo logo">
				<Link to="/" onClick={this.clearFilter.bind(this)}><img src={logo}/></Link>
			</div>
		);
	}
}

export default connect(
	state => ({
		filter : state.filter
	}),
	dispatch => ({
		onClearFilter : () => {
			dispatch(clearFilter());
		}
	})
)(Logo);


// WEBPACK FOOTER //
// ./src/app/components/Logo.js